import React, { CSSProperties } from "react";
import IconInfo from "../dynamicicons/icon-info";
import HoverTooltip from "./hover-tooltip";
import * as styles from "./info-tooltip.module.scss";
import { classArr } from "../helper/style-helper";
import whitelabel from "../whitelabel";

interface InfoTooltipProps {
	style?: CSSProperties;
	className?: string;

	color?: string;
	children?: string | React.ReactNode;
	useTextLayout?: boolean;
	fixed?: boolean;
}

export default function InfoTooltip(props: InfoTooltipProps) {
	const useTextLayout =
		props.useTextLayout ?? typeof props.children === "string";

	return (
		<HoverTooltip
			style={props.style}
			wrapperClassName={classArr(styles.container, props.className)}
			tooltip={
				useTextLayout ? (
					<span className={styles.text}>{props.children}</span>
				) : (
					props.children
				)
			}
			fixed={props.fixed}
		>
			<IconInfo
				size={16}
				color={props.color ?? whitelabel.palette.primary900}
			/>
		</HoverTooltip>
	);
}
